<template>
  <div>
    <h1 class="title">Administrator home</h1>
    <div class="content">
      <SearchGeneric
        preload="true"
        label="Cerca cliente"
        apiaddress="/users/search/"
        :terms="{ customersonly: true }"
        v-on:eventSelected="handleCustomerSelected"
        required
      ></SearchGeneric>
    </div>

    <div class="columns">
      <div class="column">
        <h2 class="subtitle">FROM</h2>
        <b-datepicker v-model="dataRange.from" inline></b-datepicker>
      </div>
      <div class="column">
        <h2 class="subtitle">TO</h2>
        <b-datepicker v-model="dataRange.to" inline></b-datepicker>
      </div>
    </div>

    <div class="buttons is-centered">
      <a
        class="button is-primary"
        v-on:click="downloadCustomerReport"
        :disabled="$ajax.anyLoading || !this.customer.id"
      >Genera e scarica</a>

      <a
        class="button is-primary"
        v-on:click="downloadCustomerReportLinear"
        :disabled="$ajax.anyLoading || !this.customer.id"
      >Genera export lineare</a>
    </div>
  </div>
</template>

<script>
import SearchGeneric from "../components/SearchGeneric";

export default {
  components: { SearchGeneric },
  data() {
    return {
      dataRange: {
        from: new Date(),
        to: new Date()
      },
      customer: {}
    };
  },
  methods: {
    downloadCustomerReport() {
      if (!this.customer.id) return;

      this.$ajax.request({
        address: `/stats/${this.customer.id}/customer`,
        method: "POST",
        responseType: "blob", // important
        data: this.dataRange,
        onSuccess: response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "export.xlsx");
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    downloadCustomerReportLinear() {
      if (!this.customer.id) return;

      this.$ajax.request({
        address: `/stats/${this.customer.id}/linear`,
        method: "POST",
        responseType: "blob", // important
        data: this.dataRange,
        onSuccess: response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "export_lineare.xlsx");
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    handleCustomerSelected(selected) {
      this.customer = selected;
    }
  }
};
</script>

<style>
.datepicker.control {
  text-align: center;
}
</style>
